export const createSearchId = (filename = '') => {
  const hasExtension = filename?.indexOf('.') !== -1
  const name = hasExtension ? filename?.substring(0, filename.lastIndexOf('.')) : filename
  return `${name || 'textSearch'}-${Date.now()}`
}

export const generateFile = (text, filename) => new File([text], filename, { type: 'text/plain' })
